import { render, staticRenderFns } from "./afterRentResultsDetail.vue?vue&type=template&id=945a6764&scoped=true&"
import script from "./afterRentResultsDetail.vue?vue&type=script&lang=js&"
export * from "./afterRentResultsDetail.vue?vue&type=script&lang=js&"
import style0 from "./afterRentResultsDetail.vue?vue&type=style&index=0&id=945a6764&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "945a6764",
  null
  
)

export default component.exports